export const unsetChannelCapabilities = () => {
  return {
    disabled: true,
    sendDisabledReason: 'NO_RECIPIENT'
  };
};